module.exports = __webpack_public_path__ + "img/about-children-bg@dt.e349336.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-children-bg@dt.svg
// module id = UPI+
// module chunks = 2